import {Banner, BannerCarousel} from "../contenful/types";
import {useEffect, useRef, useState} from "react";
import {Carousel} from "react-bootstrap";
import "./BannerCarouselComponent.scss"
import {toGrid} from "../user/ui/utils";
import {useDispatch, useSelector} from "react-redux";
import {AppState, useAppSelector} from "../RootReducer";
import {BannerJackpotAmount, getGamesFromBanners} from "../selectors/casino-selectors";
import { CasinoGameInfo} from "../http/protocol";
import {OptionalLink} from "./pagesection/HeroBannerTwoColumnsComponent";
import {JackpotCounter} from "../casino/ui/CarouselComponent";
import { getLoggedIn} from "../selectors/user-selectors";
import { isMobile } from "react-device-detect";
import {setBannerHeight} from "../casino/CasinoActions";

const getBreakpoint = (size : string) => {
    let breakpoint = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + size);
    return parseInt(breakpoint.replaceAll("px",""));
}
const getGridSizeByWindowSize = (maxGrid : number) => {
    let w = window.innerWidth;
    if(w >= getBreakpoint("xl")) {
        return Math.min(4, maxGrid);
    } else if(w >= getBreakpoint("lg")) {
        return Math.min(3, maxGrid);;
    }  else if(w >= getBreakpoint("md")) {
        return Math.min(2, maxGrid);
    }else if(w >= getBreakpoint("sm")) {
        return Math.min(2, maxGrid);
    }
    return 1;
}

export const BannerCarouselComponent = (props: { section : BannerCarousel}) => {
    const dispatch = useDispatch();
    const bannerHeight = useAppSelector(app => app.casino.bannerHeight);
    const container =  useRef<HTMLDivElement>(null);
    const [gridChange, setGridChange] = useState(false);
    const [selected, setSelected] = useState(0);
    const [gridSize, setGridSize] = useState(props.section.gridSize ?? 1);
    const loggedIn = useSelector((app : AppState) => getLoggedIn(app));
    let filteredBanners = useSelector((app : AppState) => getGamesFromBanners(app, props.section));
    const handleSelect = (selectedIndex: number, e: any) => {
        setSelected(selectedIndex);
    };


    useEffect(()=>{
        setGridSize(getGridSizeByWindowSize(props.section?.gridSize ?? 1));
        let timeout : NodeJS.Timeout | undefined;
/*         let scrolling = false; */
        const resize = () => {
            if(timeout) {
                clearTimeout(timeout);
            }
            if(!isMobile){
                setGridChange(true);
            }
            timeout = setTimeout(()=>{
                setGridSize(getGridSizeByWindowSize(props.section?.gridSize ?? 1));
                setGridChange(false);
            },200);
        }
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
        }
    },[props.section?.gridSize, selected]);

    useEffect(()=>{
        let nrOfSlides = Math.ceil(props.section.banners.length / gridSize);
        if(selected > nrOfSlides - 1) {
            setSelected(0);
        }
    },[selected, gridSize]);
    useEffect(()=>{
        dispatch(setBannerHeight(container.current?.clientHeight));
        const resize = () => {
            dispatch(setBannerHeight(container.current?.clientHeight));
        }
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
        }
    },[])
    let grid = toGrid(filteredBanners.banners, gridSize);
    let nrOfSlides = Math.ceil(props.section.banners.length / gridSize);
    let slidesCss = nrOfSlides > 1 ? "multiple-slides" : "one-slide";

    if(gridChange) {
        return (
            <div className={`container banner-carousel-container ${slidesCss} banner-grid-${gridSize} ${props.section.containerCssClass ?? ""} `}>
                <div className={"row"}>
                    {Array(gridSize).fill(1).map( (g,i) => (
                        <div key={"a" + i} className={`centered-banner col-${12/gridSize}`}>
                            <div className={"main-background loading"} >
                            </div>
                            <div className={"main-background mobile loading"}>
                            </div>
                            <div className={"action-content"}>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className={`container banner-carousel-container ${slidesCss} banner-grid-${gridSize} ${props.section.containerCssClass ?? ""} `}
             style={{ animation: `fadeIn 1s` }} ref={container}>
            <Carousel activeIndex={selected} onSelect={handleSelect} >
                {grid.map((g : Banner[], index : number) => {
                    return (
                        <Carousel.Item key={"g" + gridSize +"-"+ index}>
                            <div className={"row"}>
                                {g.map((b,i) =>
                                    <GridBanner key={gridSize + "-" + i}
                                                loggedIn={loggedIn}
                                                gridSize={gridSize}
                                                banner={b}
                                                games={filteredBanners.bannerGames}
                                                jackpots={filteredBanners.jackpots}/>)}
                            </div>
                        </Carousel.Item>
                    )
                })}
            </Carousel>
        </div>
    )
}

const hasActionButton = (linkType? : string) => {
    if(linkType == "BUTTON" || linkType == "BUTTON_AND_IMAGE") {
        return true;
    }
    return false;
}
const hasImageLink = (linkType? : string) => {
    if(linkType === "IMAGE" || linkType === "BUTTON_AND_IMAGE") {
        return true;
    }
    return false;
}
export const GridBanner = (props : { loggedIn? : boolean; banner : Banner, gridSize : number, games : CasinoGameInfo[], jackpots : BannerJackpotAmount[]}) => {
    const b = props.banner
    const game = props.games.find(g => g.id === b.gameId);
    if(!b) {
        return <></>;
    }
    if(b?.gameId && !game) {
        return <></>
    }
    let url = b.image?.fields?.file?.url;
    if(!url) {
        url = b.imageUrl;
    }
    let mobileUrl = b.mobileImage?.fields?.file?.url;
    if(!mobileUrl) {
        mobileUrl = b.mobileImageUrl;
    }
    if(!mobileUrl) {
        mobileUrl = url;
    }
    let jackpot;
    if(props.jackpots && b.jackpotId && b.jackpotCurrency) {
        jackpot = props.jackpots.find(j => j.id == b.jackpotId && b.jackpotCurrency == j.jackpotCurrency);
    }
    if(!jackpot && props.jackpots && b.jackpotId) {
        jackpot = props.jackpots.find(j => j.id == b.jackpotId);
    }
    let link = b.link;
    if(props.loggedIn && b.loggedInLink) {
        link = b.loggedInLink;
    }
    let linkText = b.linkText;
    if(props.loggedIn && b.loggedInLinkText) {
        linkText = b.loggedInLinkText;
    }

    return (
       <OptionalLink to={hasImageLink(b.linkType) ? link : undefined} game={hasImageLink(b.linkType) ? game : undefined} className={`centered-banner col-${12/props.gridSize} ${b.containerCssClass ?? ""} ${hasActionButton(b.linkType) ? "" : "no-button"}`}>
           <div className={"main-background"} style={{ backgroundImage: `url('${url}')`}}>
           </div>
           <div className={"main-background mobile"} style={{ backgroundImage: `url('${mobileUrl}')`}}>
           </div>
           {(jackpot?.amount && jackpot.currency) && (
               <div className={"banner-jackpot-container"}>
                   <JackpotCounter amount={jackpot.amount} currency={jackpot.currency} />
               </div>
           )}
           <div className={"action-content"}>
               {hasActionButton(b.linkType) && (
                   <OptionalLink className={"btn btn-banner btn-lg"} to={!hasImageLink(b.linkType) ? link : undefined} game={!hasImageLink(b.linkType) ? game : undefined} >{linkText}</OptionalLink>
               )}
           </div>


       </OptionalLink>
    )
}